import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { GridColDef } from '@mui/x-data-grid';

import { StatusChip } from '@/components/Cards/Chips/StatusChip';
import { formatDate, formatDeliveryTypeCode } from '@/utils/common';
import { getBgStatus, getLbColorStatus } from '@/utils/orders';

import { getPlatformInfo } from '../utils';

export const shipColumns = (
  handleOpenDownloadModal: (trackingId?: string) => void,
): Array<GridColDef> => [
  {
    field: 'trackingId',
    flex: 1,
    headerName: `Nº de seguimiento`,
    align: 'center',
    sortable: false,
    headerAlign: 'center',
    renderCell: (params) => (
      <Typography variant="body2" display={'inline'} sx={{ fontWeight: 'bold' }}>
        {params.row.trackingId}
      </Typography>
    ),
  },
  {
    field: 'createdAt',
    flex: 1,
    headerName: 'Fecha de creación',
    align: 'center',
    sortable: false,
    headerAlign: 'center',
    renderCell: (params) => (
      <Typography
        variant="body2"
        sx={{ display: 'inline', color: (theme) => theme.palette.grey[600] }}
      >
        {formatDate(params.row.createdAt)}
      </Typography>
    ),
  },
  {
    field: 'destination',
    flex: 1.6,
    headerName: 'Destino',
    align: 'center',
    sortable: false,
    headerAlign: 'center',
    renderCell: (params) => (
      <Typography
        variant="body2"
        sx={{ textAlign: 'left', color: (theme) => theme.palette.grey[600], display: 'inline' }}
      >
        {params.row.destination.address}
      </Typography>
    ),
  },
  {
    field: 'platform',
    flex: 1,
    headerName: 'Plataforma',
    align: 'center',
    sortable: false,
    headerAlign: 'center',
    renderCell: (params) => {
      const platformInfo = getPlatformInfo(params.row.platform);

      if (platformInfo) {
        if (!platformInfo.logo) {
          return (
            <Tooltip title={`Plataforma: ${platformInfo.platform}`} placement="top">
              <Typography
                variant="body2"
                sx={{
                  display: 'inline',
                  color: (theme) => theme.palette.grey[600],
                  fontWeight: 'bold',
                  cursor: 'help',
                  textAlign: 'center',
                }}
              >
                {platformInfo.platform}
              </Typography>
            </Tooltip>
          );
        }
        return (
          <Tooltip title={`Plataforma: ${platformInfo.platform}`} placement="top">
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <img
                src={platformInfo.logo}
                alt={platformInfo.platform}
                width={90}
                height={90}
                style={{
                  objectFit: 'contain',
                }}
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  const container = target.parentElement;
                  if (container) {
                    target.style.display = 'none';
                    const span = document.createElement('span');
                    span.textContent = platformInfo.platform;
                    span.style.cssText =
                      'font-size: 11px; color: #666; font-weight: bold; text-align: center;';
                    container.appendChild(span);
                  }
                }}
              />
            </Box>
          </Tooltip>
        );
      }

      return (
        <Typography
          variant="body2"
          sx={{
            display: 'inline',
            color: (theme) => theme.palette.grey[400],
            fontStyle: 'italic',
            textAlign: 'center',
          }}
        >
          -
        </Typography>
      );
    },
  },
  {
    field: 'deliveryType',
    flex: 0.7,
    headerName: 'Modalidad',
    align: 'center',
    sortable: false,
    headerAlign: 'center',
    renderCell: (params) => (
      <Typography
        variant="body2"
        display={'inline'}
        sx={{ fontWeight: 'bold', color: (theme) => theme.palette.grey[600] }}
      >
        {formatDeliveryTypeCode(params.row.deliveryType)}
      </Typography>
    ),
  },
  {
    field: 'status',
    flex: 1,
    headerName: 'Estatus',
    align: 'center',
    sortable: false,
    headerAlign: 'center',
    renderCell: (params) => (
      <Box>
        <StatusChip
          status={params.row.statusNameES}
          color={getLbColorStatus(params.row.status)}
          bg={getBgStatus(params.row.status)}
        />
      </Box>
    ),
  },
  {
    field: 'actions',
    flex: 0.7,
    headerName: 'Acciones',
    align: 'center',
    sortable: false,
    headerAlign: 'center',
    resizable: false,
    renderCell: (params) => {
      return (
        <Box>
          <Tooltip followCursor title="Descarga de etiquetas" placement="top">
            <IconButton
              color="primary"
              onClick={() => handleOpenDownloadModal(params.row.trackingId)}
            >
              <CloudDownloadOutlinedIcon />
            </IconButton>
          </Tooltip>
        </Box>
      );
    },
  },
];
